import { Column } from "../../../Shared/FlexDiv/FlexDiv";
import { Urls } from "../../../../Urls";
import {
  Activity,
  isMobile,
  currentRequestTimeStamp,
} from "../../../../Constants";
import mixpanel from "mixpanel-browser";
import Modal from "../../../Shared/PopupModal/PopupModal";
import UpgradeModal from "../../../UpgradeModal/UpgradeModal";
import UploadExcel from "./UploadExcel/UploadExcel";

const Uploads = ({ upload_allowed, allowedLanes, onClose = "" }) => {
  const sampleFormat = (e) => {
    Activity([
      {
        screen: "My Freight Benchmark",
        module: "My Freight Benchmark",
        user_activity: "Sample template download button clicked",
        timestamp: currentRequestTimeStamp(),
      },
    ]);
    mixpanel.track(`User has clicked on format download button`, {
      ApplicationName: `${Urls.mixpanelappname}`,
      ScreenName: "LoRRI-Benchmark",
      ModuleName: "landing_page",
      ActivityLog: "userClickedFormatDownloadButton",
      Data: `None`,
      Definition: `User has clicked on format download button`,
      ActivityType: "event_view",
      UserName: `${localStorage.getItem("userdetails")}`,
      UserEmail: `${localStorage.getItem("useremail")}`,
      CompanyName: `${localStorage.getItem("companyname")}`,
    });
  };

  return (
    <Column>
      <div className="row">
        <div className="col-md-9" style={{fontSize: "13px"}}>
          Please upload the lanes in the Standard Format
        </div>
        <div className="col-md-3">
          <a
            className={`btn btn-sm ${
              isMobile() ? "btn-primary" : "btn-link"
            } fa fa-download`}
            href="https://lnclientdata.blob.core.windows.net/benchmark-uploads/UploadFormat.xlsx"
            target="_blank"
            rel="noopener noreferrer"
            title="format-download"
            style={{ color: "white" }}
            onClick={(e) => sampleFormat(e)}
          >
            <span></span>
          </a>
        </div>
      </div>
      <div className="text-center mt-2">
        {upload_allowed && allowedLanes > 0 ? (
          <Modal
            buttonLabel={
              <>
                <i className="fas fa-upload mr-2" />
                Upload Lanes
              </>
            }
            buttonClass="btn btn-success"
            content={
              <UploadExcel onClose={onClose} allowedLanes={allowedLanes} />
            }
            title={`Upload Lanes for LoRRI Benchmark`}
            id="closebutton"
            screenName="My Freight Benchmark"
            moduleName="My Freight Benchmark"
            activityName={`User clicked Upload Lanes button`}
          />
        ) : (
          <UpgradeModal
            screenName="My Freight Benchmark"
            moduleName="My Freight Benchmark"
            feature="Upload Lanes"
            activityName={`Upload Lanes button clicked`}
            buttonClass="btn btn-success upload-file-button-enquiry-my-account"
            buttonTitle={
              <h4 style={{ marginLeft: "3%" }}>
                <b>Upload Lanes for LoRRI Benchmark</b>
              </h4>
            }
            buttonLabel={
              <>
                <i className="fas fa-upload"></i>
                <a style={{ fontSize: "14px" }}>Upload Lanes </a>
              </>
            }
          />
        )}
      </div>
    </Column>
  );
};

export default Uploads;
